import { render, staticRenderFns } from "./DetailsLanguageDropdown.vue?vue&type=template&id=7914074d&scoped=true"
import script from "./DetailsLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./DetailsLanguageDropdown.vue?vue&type=script&lang=js"
import style0 from "./DetailsLanguageDropdown.vue?vue&type=style&index=0&id=7914074d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7914074d",
  null
  
)

export default component.exports